import { render, staticRenderFns } from "./OrganisationDashboard.vue?vue&type=template&id=87c278a2&"
import script from "./OrganisationDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganisationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports